import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import tinymce from 'tinymce';
import { environment } from 'src/environments/environment';

// const jsDemoImagesTransform = document.createElement('script');
//    jsDemoImagesTransform.type = 'text/javascript';
//    jsDemoImagesTransform.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
//    // Load generated scripts.
//    document.head.appendChild(jsDemoImagesTransform);
// const jsDemoImagesTransform = document.createElement('script');
// jsDemoImagesTransform.type = 'text/javascript';
// jsDemoImagesTransform.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
// document.head.appendChild(jsDemoImagesTransform);
@Component({
  selector: 'app-tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.css'],
})
export class TinymceComponent implements OnInit {
  private static nextInstanceId = 0;

  @Output() GetQuestionBodyContent: EventEmitter<any> = new EventEmitter<any>();
  // @Output() GetLatexBodyContent: EventEmitter<any> = new EventEmitter<any>();
  // @Output() RemoveLatexBodyContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetAnswerChoiceContent: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetAnswerChoiceNoteContent: EventEmitter<any> =
    new EventEmitter<any>();
  // @Output() GetCommentboxContent: EventEmitter<any> = new EventEmitter<any>();
  // @Output() GetCommentboxContent1: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetLatexBodyContentchanges: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() GetCommentboxContent1: EventEmitter<any> = new EventEmitter<any>();
  @Output() GetCommentboxContent: EventEmitter<any> = new EventEmitter<any>();
  @Input() ALLAboveNoneAboveChoiceflag: boolean;
  @Input() QuestionBodyget: any;
  // @Input() Previewflag:string;
  // @Input() safehtmlStr?:string;
  // @Input() Previewquestion:string;
  @Input() RTEFlag: string;

  editorId: string;
  editorId2: string;
  editorId3: string;

  ref: any;
  constructor() {
    const instanceId = TinymceComponent.nextInstanceId++;
    this.editorId = `editor-${instanceId}`;
    this.editorId2 = `editor2-${instanceId}`;
    this.editorId3 = `editor3-${instanceId}`;
    this.GetContent();
  }

  ngOnInit(): void {
    this.GetContent();
    console.log(this.RTEFlag, 'RTEFlag');
    console.log(this.QuestionBodyget, 'QuestionBodyget');
  }

  title = 'tinymce6';
  public content: string = '';
  public Dirty: boolean = false;
  public options: Object = {
    //  base_url: '/tinymce', // Root for resources
    //  suffix: '.min',        // Suffix to use when loading resources

    // Add wiris plugin
    //  external_plugins: {
    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
    //  },

    base_url: 'https://www.perfectlearningapp.com/tinymce',

    // base_url: 'http://uat.perfectlearningapp.com/tinymce',

    // base_url: 'https://dev.perfectlearningapp.com/tinymce',

    // base_url: '/tinymce',
    suffix: '.min', // Suffix to use when loading resources
    init_instance_callback: function (editor: {
      on: (arg0: string, arg1: (e: any) => void) => void;
    }) {
      editor.on('Dirty', function (e) {
        console.log('Editor is dirty!');
      });
    },

    // Add wiris plugin
    //  init_instance_callback: function (editor: { on: (arg0: string, arg1: (e: any) => void) => void; }) {
    //   editor.on('keyup', function (e) {

    //     e.GetContent();

    //   });
    // editor.on('GetContent', function (e) {
    //   e.content;
    //   console.log(e.content,'content');

    // });
    // },
    //  external_plugins: {

    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`,

    //  },

    extended_valid_elements: '*[.*]',

    menu: {
      file: { title: 'File', items: ' preview |deleteallconversations' },
      edit: {
        title: 'Edit',
        items: 'undo redo | paste pastetext | searchreplace',
      },
      view: {
        title: 'View',
        items:
          'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
      },
      insert: {
        title: 'Insert',
        items:
          'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime | eqneditor',
      },
      format: {
        title: 'Format',
        items:
          'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
      },
      table: {
        title: 'Table',
        items:
          'inserttable | cell row column | advtablesort | tableprops deletetable',
      },
    },
    // paste_data_images: false,
    // automatic_uploads: true,

  //   images_upload_handler: (blobInfo:any, success:any, failure:any) => {
  //   const formData = new FormData();
  //   formData.append('file', blobInfo.blob(), blobInfo.filename());
  //   console.log(blobInfo.blob(),'blobInfo.blob()',  blobInfo.filename());

  //     return
  // fetch('https://api.perfectlearningapp.com/upload/image', {
  //   method: 'POST',
  //   body: formData,
  // })
  //   .then(res => res.json())
  //   .then(result => {
  //     // IMPORTANT: API must return a public image URL
  //     // Example response: { url: "https://cdn.site.com/img/abc.jpg" }
  //     success(result.url);
  //   })
  //   .catch(() => {
  //     failure('Image upload failed');
  //   });
  //   },

    importcss_append: true,
    autosave_ask_before_unload: true,
    promotion: false,
    branding: false,
    elementpath: false,
    advlist_bullet_styles: 'default,circle,disc,square',
    htmlAllowedTags: ['.*'],
    htmlAllowedAttrs: ['.*'],
    plugins: [
      'eqneditor',
      'image',
      'media',
      'table',
      'charmap',
      'code',
      'anchor',
      'link',
      'autosave',
      'directionality',
      'emoticons',
      'fullscreen',
      'importcss',
      'insertdatetime',
      'lists',
      'nonbreaking',
      'pagebreak',
      'preview',
      'quickbars',
      'save',
      'searchreplace',
      'wordcount',
      'visualblocks',
      'visualchars',
    ],
    toolbar:
      'eqneditor undo redo styleselect bold italic  alignleft aligncenter alignright alignjustify  outdent indent numlist bullist  preview searchreplace code anchor link restoredraft  charmap ltr rtl emoticons fullscreen  insertdatetime pagebreak quickimage save wordcount visualblocks visualchars tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
    eqneditor_server: 'fxtex.codecogs.com',
    eqneditor_licence: environment.codecogsLicenceKey || '',
    eqneditor_design: {
      colour: '#1a73e8',
    },
    //  tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry
    // table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |
  };
  public options1: Object = {
    //  base_url: '/tinymce', // Root for resources
    //  suffix: '.min',        // Suffix to use when loading resources

    // Add wiris plugin
    //  external_plugins: {
    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
    //  },

    base_url: 'https://www.perfectlearningapp.com/tinymce',

    // base_url: 'http://uat.perfectlearningapp.com/tinymce',

    // base_url: 'https://dev.perfectlearningapp.com/tinymce',
    // base_url: '/tinymce',
    suffix: '.min',
    height: 300, // Suffix to use when loading resources
    init_instance_callback: function (editor: {
      on: (arg0: string, arg1: (e: any) => void) => void;
    }) {
      editor.on('Dirty', function (e) {
        console.log('Editor is dirty!');
      });
    },

    // Add wiris plugin
    //  init_instance_callback: function (editor: { on: (arg0: string, arg1: (e: any) => void) => void; }) {
    //   editor.on('keyup', function (e) {

    //     e.GetContent();

    //   });
    // editor.on('GetContent', function (e) {
    //   e.content;
    //   console.log(e.content,'content');

    // });
    // },
    //  external_plugins: {

    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`,

    //  },

    extended_valid_elements: '*[.*]',

    menu: {
      file: { title: 'File', items: ' preview |deleteallconversations' },
      edit: {
        title: 'Edit',
        items: 'undo redo | paste pastetext | searchreplace',
      },
      view: {
        title: 'View',
        items:
          'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
      },
      insert: {
        title: 'Insert',
        items:
          'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime | eqneditor',
      },
      format: {
        title: 'Format',
        items:
          'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
      },
      table: {
        title: 'Table',
        items:
          'inserttable | cell row column | advtablesort | tableprops deletetable',
      },
    },

    importcss_append: true,
    autosave_ask_before_unload: true,
    promotion: false,
    branding: false,
    elementpath: false,
    advlist_bullet_styles: 'default,circle,disc,square',
    htmlAllowedTags: ['.*'],
    htmlAllowedAttrs: ['.*'],
    plugins: [
      'eqneditor',
      'image',
      'media',
      'table',
      'charmap',
      'code',
      'anchor',
      'link',
      'autosave',
      'directionality',
      'emoticons',
      'fullscreen',
      'importcss',
      'insertdatetime',
      'lists',
      'nonbreaking',
      'pagebreak',
      'preview',
      'quickbars',
      'save',
      'searchreplace',
      'wordcount',
      'visualblocks',
      'visualchars',
    ],
    toolbar:
      'eqneditor undo redo styleselect bold italic  alignleft aligncenter alignright alignjustify  outdent indent numlist bullist  preview searchreplace code anchor link restoredraft  charmap ltr rtl emoticons fullscreen  insertdatetime pagebreak quickimage save wordcount visualblocks visualchars tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
    eqneditor_server: 'fxtex.codecogs.com',
    eqneditor_licence: environment.codecogsLicenceKey || '',
    eqneditor_design: {
      colour: '#1a73e8',
    },
    //  tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry
    // table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |
  };
  public options2: Object = {
    //  base_url: '/tinymce', // Root for resources
    //  suffix: '.min',        // Suffix to use when loading resources

    // Add wiris plugin
    //  external_plugins: {
    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`
    //  },

    base_url: 'https://www.perfectlearningapp.com/tinymce',

    // base_url: 'http://uat.perfectlearningapp.com/tinymce',

    // base_url: 'https://dev.perfectlearningapp.com/tinymce',
    // base_url: '/tinymce',
    suffix: '.min',
    height: 465, // Suffix to use when loading resources
    init_instance_callback: function (editor: {
      on: (arg0: string, arg1: (e: any) => void) => void;
    }) {
      editor.on('Dirty', function (e) {
        console.log('Editor is dirty!');
      });
    },

    // Add wiris plugin
    //  init_instance_callback: function (editor: { on: (arg0: string, arg1: (e: any) => void) => void; }) {
    //   editor.on('keyup', function (e) {

    //     e.GetContent();

    //   });
    // editor.on('GetContent', function (e) {
    //   e.content;
    //   console.log(e.content,'content');

    // });
    // },
    //  external_plugins: {

    //      'tiny_mce_wiris' : `${window.location.href}/node_modules/@wiris/mathtype-tinymce6/plugin.min.js`,

    //  },

    extended_valid_elements: '*[.*]',

    menu: {
      file: { title: 'File', items: ' preview |deleteallconversations' },
      edit: {
        title: 'Edit',
        items: 'undo redo | paste pastetext | searchreplace',
      },
      view: {
        title: 'View',
        items:
          'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments',
      },
      insert: {
        title: 'Insert',
        items:
          'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor tableofcontents | insertdatetime | eqneditor',
      },
      format: {
        title: 'Format',
        items:
          'bold italic underline strikethrough superscript subscript codeformat | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat',
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount',
      },
      table: {
        title: 'Table',
        items:
          'inserttable | cell row column | advtablesort | tableprops deletetable',
      },
    },

    importcss_append: true,
    autosave_ask_before_unload: true,
    promotion: false,
    branding: false,
    elementpath: false,
    advlist_bullet_styles: 'default,circle,disc,square',
    htmlAllowedTags: ['.*'],
    htmlAllowedAttrs: ['.*'],
    plugins: [
      'eqneditor',
      'image',
      'media',
      'table',
      'charmap',
      'code',
      'anchor',
      'link',
      'autosave',
      'directionality',
      'emoticons',
      'fullscreen',
      'importcss',
      'insertdatetime',
      'lists',
      'nonbreaking',
      'pagebreak',
      'preview',
      'quickbars',
      'save',
      'searchreplace',
      'wordcount',
      'visualblocks',
      'visualchars',
    ],
    toolbar:
      'eqneditor undo redo styleselect bold italic  alignleft aligncenter alignright alignjustify  outdent indent numlist bullist  preview searchreplace code anchor link restoredraft  charmap ltr rtl emoticons fullscreen  insertdatetime pagebreak quickimage save wordcount visualblocks visualchars tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
    eqneditor_server: 'fxtex.codecogs.com',
    eqneditor_licence: environment.codecogsLicenceKey || '',
    eqneditor_design: {
      colour: '#1a73e8',
    },
    //  tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry
    // table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |
  };

  GetLatexBodyContentchanges1() {}
  GetContent() {
    if (this.RTEFlag == 'QuestionBody') {
      // var myContent = tinymce;
      // console.log(myContent);
      if (tinymce.activeEditor?.isDirty) {
        if (tinymce.activeEditor.isDirty()) {
          this.GetLatexBodyContentchanges.emit(tinymce.activeEditor.isDirty());
        } else {
          this.GetLatexBodyContentchanges.emit(false);
        }
      }
      console.log(this.QuestionBodyget,
        'this.QuestionBodyget from tinymce component==='
      );

      this.GetQuestionBodyContent.emit(this.QuestionBodyget);
    }
    if (this.RTEFlag == 'AnswerChoice') {
      if (tinymce.activeEditor?.isDirty) {
        if (tinymce.activeEditor.isDirty()) {
          this.GetLatexBodyContentchanges.emit(tinymce.activeEditor.isDirty());
        } else {
          this.GetLatexBodyContentchanges.emit(false);
        }
      }
      this.GetAnswerChoiceContent.emit(this.QuestionBodyget);
    }
    if (this.RTEFlag == 'AnswerChoiceNote') {
      if (tinymce.activeEditor?.isDirty) {
        if (tinymce.activeEditor.isDirty()) {
          this.GetLatexBodyContentchanges.emit(tinymce.activeEditor.isDirty());
        } else {
          this.GetLatexBodyContentchanges.emit(false);
        }
      }
      this.GetAnswerChoiceNoteContent.emit(this.QuestionBodyget);
    }
    if (this.RTEFlag == 'Submit for review') {
      this.GetCommentboxContent1.emit(this.QuestionBodyget);
    }
    if (this.RTEFlag == 'Commentbox') {
      this.GetCommentboxContent.emit(this.QuestionBodyget);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['QuestionBodyget']) {
      if (this.RTEFlag == 'QuestionBody') {
        this.GetQuestionBodyContent.emit(this.QuestionBodyget);
      }
      if (this.RTEFlag == 'AnswerChoice') {
        this.GetAnswerChoiceContent.emit(this.QuestionBodyget);
      }
      if (this.RTEFlag == 'AnswerChoiceNote') {
        this.GetAnswerChoiceNoteContent.emit(this.QuestionBodyget);
      }
    }
  }
}
